import { createBrowserHistory } from "history";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import HttpHeader from "../../../header";
import { IAppState } from "../../../store";
import styles from "./index.module.css";
import { TopBar } from '../../TopBar/TopBar';
import { Container, Dialog, Hidden } from '@material-ui/core';
import SideBar from './Sidebar';
import Tracking from './VehicleTracking';
import Reports from './Reports';
import Bookings from './Bookings';
import BookingsList from './Bookings/BookingsList';
import Invoices from './Invoices';
import Vehicles from './Vehicles';
import Account from './account';
import Vehicle from './Vehicle';
import Drivers from './Drivers';
import BookingManagement from './BookingManagement';
import Invoice from './Invoices/Invoice';
import AddDriver from './Drivers/AddDriver';
import CreditNotes from "./CreditNotes";
import CreditNote from "./CreditNotes/CreditNote";
import PortalDashboard from "./Dashboard";
import ServiceRequestsList from './ServiceRequests/ServiceRequestsList';
import CreateServiceRequest from './ServiceRequests/CreateServiceRequest';
import ServiceRequestDetails from './ServiceRequests/ServiceRequestDetails';
import ReviewScheduledService from './ServiceRequests/ReviewScheduledService';
import ModifyScheduledService from './ServiceRequests/ModifyScheduledService';
import FleetAllocations from "./FleetAllocations/FleetAllocations";
import ProtectedRoute from "../../../routes/ProtectedRoute";
import Authenticator from "../Auth"
import { AuthStates } from "../../../reducers/auth/types";

interface IProps {

}

export const history = createBrowserHistory();

const httpHeader = HttpHeader.getInstance();

const CustomerPortal: React.FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const navigationHistory = useHistory();
  const location = useLocation();
  // Tracking (live map) and Reports (tracking-report map + trip table) both need their own
  // left/right panels — the default Container maxWidth + rightCol's large top/bottom margins
  // were designed for regular scrolling content pages and leave the map cramped. Widen/heighten
  // just these routes; every other page keeps the standard layout untouched.
  const isWideLayoutPage = location.pathname.startsWith("/account/tracking") || location.pathname.startsWith("/account/reports");
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const authState = useSelector((state: IAppState) => state.authReducer);
  const [authDialogOpen, setAuthDialogOpen] = useState<boolean>(false);

  const onSignIn = () => {
    setAuthDialogOpen(false);
  }
  const handleDialogClose = () => {
    if (authState.state !== AuthStates.SIGNED_IN) {
      navigationHistory.push("/");
    }
    setAuthDialogOpen(false);
  };

  const logoSize = website.logoSize || 40
  const topBarHeight = logoSize > 50 ? logoSize + 20 : 70

  const routes = [
    { path: "/account/dashboard", component: PortalDashboard, exact: true },
    { path: "/account/bookings", component: BookingsList, exact: true },
    { path: "/account/fleet-allocations", component: FleetAllocations, exact: true },
    { path: "/account/bookings/:id", component: BookingManagement },
    { path: "/account/fleet-allocations/:id", component: BookingManagement },
    { path: "/account/tracking", component: Tracking },
    { path: "/account/reports", component: Reports, exact: true },
    { path: "/account/invoices", component: Invoices, exact: true },
    { path: "/account/invoices/:id", component: Invoice },
    { path: "/account/credit-notes", component: CreditNotes, exact: true },
    { path: "/account/credit-notes/:id", component: CreditNote, exact: true },
    { path: "/account/service-requests", component: ServiceRequestsList, exact: true },
    { path: "/account/scheduled-service/:id/modify", component: ModifyScheduledService, exact: true },
    { path: "/account/scheduled-service/:id", component: ReviewScheduledService, exact: true },
    { path: "/account/service-request/new", component: CreateServiceRequest, exact: true },
    { path: "/account/service-request/:id", component: ServiceRequestDetails, exact: true },
    { path: "/account/vehicles", component: Vehicles, exact: true },
    { path: "/account/vehicles/:id", component: Vehicle },
    { path: "/account/drivers/new", component: AddDriver },
    { path: "/account/drivers", component: Drivers },
    { path: "/account", component: Account, exact: true },
  ];

  return (
    <>
      <TopBar
        height={topBarHeight}
        logoSize={logoSize}
        accountScreen
      />
      <div className={styles.container}>
        <Container>
          <div className="flex" style={{ height: "100vh" }}>
            <Hidden xsDown>
              <SideBar />
            </Hidden>
            <div
              className={isWideLayoutPage ? styles.rightColTracking : styles.rightCol}
              style={isWideLayoutPage ? { top: topBarHeight } : undefined}
            >
              <Switch>
                {routes.map((route, i) => (
                  <ProtectedRoute
                    key={i}
                    {...route}
                    setAuthDialogOpen={setAuthDialogOpen}
                    authDialogOpen={authDialogOpen}
                  />
                ))}
              </Switch>
            </div>
            <Dialog
              open={authDialogOpen}
              onClose={handleDialogClose}
              maxWidth="md"
            >
              <div className={styles.authDialog}>
                <Authenticator onSignIn={onSignIn} />
              </div>
            </Dialog>
          </div>
        </Container>
      </div>
    </>
  );
};

export default CustomerPortal
